import { Route } from '@angular/router';
import { LoginGuard, PermissionGuard } from '@simac/ui';

export const SerialnumberRoute: Route = {
  path: 'serialnumber',
  children: [
    {
      path: '',
      loadComponent: () => import('./pages/serialnumber.component').then((m) => m.SerialnumberComponent),
    },
  ],
  canActivate: [LoginGuard, PermissionGuard],
};
